import { Translation } from 'types/translation'

export const warningSections = [
  'profile',
  'skills',
  'industries',
  'roles',
  'employers',
  'projects',
  'education',
  'courses',
  'certificates',
  'competences',
  'references',
  'languages',
] as const

export type WarningSection = (typeof warningSections)[number]

export interface IItemMissingField {
  section: WarningSection
  itemId: number | string
  itemIndex: number
  missingFields: string[]
  translations?: Translation[]
  languageCode?: string
}

export interface ISectionWarningSummary {
  section: WarningSection
  missingFields: number
  affectedItems: number
}

export type SectionWarningsMap = Record<WarningSection, ISectionWarningSummary>
export type SectionItemsMap = Record<WarningSection, IItemMissingField[]>

export interface IProfileWarningsResult {
  totalMissingFields: number
  sectionsWithWarnings: number
  sections: SectionWarningsMap
  items: IItemMissingField[]
  itemsBySection: SectionItemsMap
}
